import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
  actions: {
    async updateAmbulanceRequestStatus ({ }, options) {
      try {
        return (await Vue.http.post(this.state.baseUrl + '/ambulancerequest/update/status/', options)).data
      } catch (e) {
        console.log(e)
        throw e
      }
    },
    async getAmbulanceRequest ({ }, endpointName) {
      try {
        return (await Vue.http.get(this.state.baseUrl + '/ambulancerequest/' + endpointName)).data || []
      } catch (e) {
        console.log(e)
      }
    },
    async updateAmbulanceCallStatus ({ state }, options) {
      try {
        return (await Vue.http.put(this.state.baseUrl + '/ambulancerequest/update/message/chat/callstatus/' + options.requestId, {
          status: options.status
        })).data
      } catch (e) {
        console.log(e)
      }
    },
    async saveLocationUpdatesForAmbulance ({ }, data) {
      try {
        return (await Vue.http({
          method: 'post',
          url: this.state.baseUrl + '/locationinfo/app/track/ambulance',
          data: [data],
        })).data
      } catch (e) {
        console.log(e)
      }
    },
    async updateObd2Data ({ }, options) {
      try {
        return (await Vue.http.post(this.state.baseUrl + '/endpointservice/' + options.endpointName + '/obd2data/_update/', options.data)).data
      } catch (e) {
        console.log(e)
      }
    },
    async getObd2data ({ }, options) {
      try {
        return (await Vue.http.get(this.state.baseUrl + '/obd2data/' + options.endpointName)).data
      } catch (e) {
        console.log(e)
      }
    },
    async updateAmbulanceFeedback ({ state }, options) {
      return (await Vue.http.post(this.state.baseUrl + '/ambulancerequest/update/feedback/' + options.ambulanceRequestId, options.feedback)).data
    },
    async getAmbulanceRequestById ({ state }, requestId) {
      try {
        return (await Vue.http.get(this.state.baseUrl + '/ambulancerequestbyid/' + requestId)).data
      } catch (e) {
        console.log(e)
      }
    },
  }
}
